import { CircleCheck } from "lucide-react"
import { Progress } from "../ui/progress"
import React from "react";
import { getColorClasses } from "./SubscriptionProgress";

export function TrialStartedToast(){
    const [progress, setProgress] = React.useState(0);

    const { progressIndicatorColor, progressBgColor } = getColorClasses('success');

    React.useEffect(() => {
        const interval = setInterval(() => {
            setProgress((prevProgress) => {
                if (prevProgress >= 100) {
                    clearInterval(interval);
                    return 100;
                }
                return prevProgress + 1;
            });
        }, 50);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="flex flex-col gap-2">
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                    <CircleCheck
                        className="text-text-white rounded-full bg-[var(--semantic-success-500)] shadow-[0_0_0_4px_rgba(0,169,127,0.2)]"
                        fill="var(--semantic-success-500)"
                    />
                    <p className="text-sm font-bold">Your <span className="text-semantic-success-500">31-day free</span> trial has started!</p>
                </div>
            </div>

            <div className="text-sm ml-8">
                <span className="text-semantic-success-500">100 free credits</span> have been added to your account.
            </div>

            <div className="mt-4">
                <Progress value={progress} className={`transition-all ${progressBgColor}`} indicatorClassName={progressIndicatorColor} style={{ transitionDuration: '5000ms' }} />
            </div>
        </div>
    )
}